<template>
  <div class="body-acao">
    <div id="title">Central da ação</div>
    <div id="conteudo-central">
      <div id="menu-lateral">
        <div id="menu">
          <div v-for="menuItem in menu">
            <button class="menu-item" :class="{ 'menu-item-selecionado': menuAtivo == menuItem.valorMenu }"
              @click="abrirMenu(menuItem)">
              {{ menuItem.valorMenu }}
            </button>
          </div>
        </div>
      </div>
      <div id="conteudo">
        <div v-if="menuAtivo == ''">
          <h2>Central da Ação</h2>
        </div>
        <RouterView />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import router from "@/router";
import { useRoute } from "vue-router";

const props = defineProps({
  acaoId: {
    type: String,
    required: true,
  },
});

const route = useRoute();

const menu = ref([
  {
    valorMenu: "Atividades",
    valorRota: "atividades-central-coordenacao",
  },
  /*
  {
    valorMenu: "Tarefas",
    valorRota: "tarefas-central-coordenacao",
  },
  */
  {
    valorMenu: "Notícias",
    valorRota: "noticias-central-coordenacao",
  },
  {
    valorMenu: "Parcerias",
    valorRota: "parcerias-central-coordenacao",
  },
]);
const menuAtivo = ref("Atividades");

function abrirMenu(menuItem) {
  router.push({
    name: menuItem.valorRota,
    params: { id: props.acaoId || route.params.id },
  });
  menuAtivo.value = menuItem.valorMenu;
}

// Sincroniza o item ativo com a rota atual (inclusive no refresh)
function sincronizarMenuComRota() {
  const item = menu.value.find((m) => m.valorRota === route.name);
  if (item) menuAtivo.value = item.valorMenu;
}

watch(
  () => props.acaoId,
  (acaoId) => {
    if (acaoId) {
      props.acaoId = acaoId;
    }
  },
  { immediate: true } // faz a primeira chamada assim que o componente monta
);

watch(() => route.name, sincronizarMenuComRota);

onMounted(() => {
  sincronizarMenuComRota();
});
</script>

<style scoped>
.body-acao {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start;
  margin-top: 2rem;
  width: 100%;
  height: 100%;
  color: var(--branco);
  border-radius: 5px;

}

#conteudo-central {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
}

#title {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1rem;
  background-color: var(--roxo-primario);
  color: var(--branco);
  padding: 12px 15px;
  border-radius: 5px 5px 0 0;
}

#menu-lateral {
  background-color: var(--roxo-primario);
  flex-shrink: 0;
  width: 180px;
  border: 1px solid var(--roxo-primario);


}

#menu {
  background-color: var(--roxo-primario);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.menu-item {
  width: 100%;
  padding: 12px 16px;
  font-size: 0.9rem;

  background-color: transparent;
  color: var(--branco);
  border: none;
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  text-align: center;
}

.menu-item:hover {
  background-color: hsla(0, 0%, 100%, 0.1);
  color: var(--branco);
}

.menu-item-selecionado {
  background-color: var(--branco) !important;
  color: var(--roxo-primario) !important;
}

#conteudo {
  width: 100%;
  padding: 1rem;
  color: var(--branco);
  background-color: var(--roxo-escuro);


}

h2 {
  text-align: center;
}

@media (max-width: 768px) {
  .body-acao {
    flex-direction: column !important;
    margin-top: 1rem;
  }

  #conteudo-central {
    flex-direction: column;
  }

  #menu-lateral {
    width: 100%;
  }

  #menu {
    width: 100%;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
  }

  .menu-item {
    text-align: center;
  }

  #conteudo {
    padding: 12px;
  }
}
</style>
